import { ReportProfileDelegateAccess } from '../../../profile/report-profile-delegate-access';

export class FileShareReportProfileDelegate extends ReportProfileDelegateAccess {
  isAnonymousUser: boolean;
  isApplication: boolean;
  foldersAccessed: string[];
}
